import languages from "./languages";

export default (langCode) => {
  const languageIndex = languages.findIndex((lang) => lang.code === langCode.toLowerCase());

  return languageIndex !== -1 ? languages[languageIndex].name : langCode;
};
